import {type MouseEvent} from "react";
import {useHistory} from "react-router";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ChevronRightIcon} from "@pg-design/icons-module";
import {getAnalyticsSessionId} from "@pg-mono/algolytics";
import {pluralize} from "@pg-mono/string-utils";

import {PropertyCarousel} from "../../../property/components/property_carousel/PropertyCarousel";
import {useAppSelector} from "../../../store/hooks";
import {getSemanticSearchModalSize} from "../../tracking/get_semantic_search_modal_size";
import {hitAiAssistantOffers} from "../../tracking/semantic_search_gtm_events";
import {trackAmplitudeSemanticSearchSelectItem} from "../../tracking/track_amplitude_semantic_search_select_item";
import {SemanticSearchFiltersDto} from "../../types/SemanticSearchFiltersDto";
import {SemanticSearchPropertyDto} from "../../types/SemanticSearchPropertyDto";
import {buildSemanticSearchOfferListUrl} from "../../utils/build_semantic_search_offer_list_url";
import {SemanticSearchPropertyListTile} from "./SemanticSearchPropertyListTile";

const offersPluralize = pluralize(["oferta", "oferty", "ofert"]);
const MAX_LISTING_REGIONS = 20;

interface Props {
    properties?: SemanticSearchPropertyDto[][];
    filters?: SemanticSearchFiltersDto;
    count?: number;
}

function flattenProperties(properties: SemanticSearchPropertyDto[][]): SemanticSearchPropertyDto[] {
    return properties.flatMap((group) => group);
}

export function SemanticSearchPropertyList(props: Props) {
    const {properties, filters, count} = props;
    const history = useHistory();
    const modalSize = useAppSelector((state) => getSemanticSearchModalSize(state.semanticSearchModal.surfacePhase));

    const items = properties ? flattenProperties(properties) : [];
    const listingUrl = buildSemanticSearchOfferListUrl(filters);
    const shouldShowListingLink = !!listingUrl && (filters?.regions?.length ?? 0) <= MAX_LISTING_REGIONS;
    const listingLinkLabel = typeof count === "number" ? `Zobacz wszystkie ${count} ${offersPluralize(count)}` : "Zobacz wszystkie oferty";

    const handleListingLinkClick = (event: MouseEvent<HTMLElement>) => {
        hitAiAssistantOffers(listingLinkLabel, filters?.regions ?? []);

        trackAmplitudeSemanticSearchSelectItem({
            modalSize,
            analyticSessionId: getAnalyticsSessionId(),
            item: {itemCategory: "see_all_offers", itemName: listingLinkLabel}
        });

        const isPlainLeftClick = event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;

        if (!listingUrl || event.defaultPrevented || !isPlainLeftClick) return;

        event.preventDefault();
        history.push(listingUrl);
    };

    if (!properties || properties.length === 0) {
        return null;
    }

    if (items.length === 0) {
        return null;
    }

    return (
        <div className={propertyListSection}>
            <PropertyCarousel ariaLabel="Mieszkania dopasowane przez Doradcę AI" itemCount={items.length} className={carouselWrapper}>
                {items.map((property, index) => (
                    <SemanticSearchPropertyListTile key={`${property.id}-${index}`} property={property} index={index} />
                ))}
            </PropertyCarousel>

            {shouldShowListingLink && (
                <Button
                    variant="none_secondary"
                    size="small"
                    as="a"
                    href={listingUrl}
                    className={listingLinkButton}
                    iconRight={ChevronRightIcon}
                    onClick={handleListingLinkClick}
                >
                    {listingLinkLabel}
                </Button>
            )}
        </div>
    );
}

const propertyListSection = css({
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    minWidth: 0
});

const carouselWrapper = css({
    borderTop: "1px solid var(--colors-gray-300)",
    pt: 2
});

const listingLinkButton = css({
    alignSelf: "flex-start",
    p: 0,
    minHeight: "auto",
    textTransform: "uppercase",
    fontWeight: 700
});
import {type MouseEvent} from "react";
import {useHistory} from "react-router";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ChevronRightIcon} from "@pg-design/icons-module";
import {getAnalyticsSessionId} from "@pg-mono/algolytics";
import {pluralize} from "@pg-mono/string-utils";

import {PropertyCarousel} from "../../../property/components/property_carousel/PropertyCarousel";
import {useAppSelector} from "../../../store/hooks";
import {getSemanticSearchModalSize} from "../../tracking/get_semantic_search_modal_size";
import {hitAiAssistantOffers} from "../../tracking/semantic_search_gtm_events";
import {trackAmplitudeSemanticSearchSelectItem} from "../../tracking/track_amplitude_semantic_search_select_item";
import {SemanticSearchFiltersDto} from "../../types/SemanticSearchFiltersDto";
import {SemanticSearchPropertyDto} from "../../types/SemanticSearchPropertyDto";
import {buildSemanticSearchOfferListUrl} from "../../utils/build_semantic_search_offer_list_url";
import {SemanticSearchPropertyListTile} from "./SemanticSearchPropertyListTile";

const offersPluralize = pluralize(["oferta", "oferty", "ofert"]);
const MAX_LISTING_REGIONS = 20;

interface Props {
    properties?: SemanticSearchPropertyDto[][];
    filters?: SemanticSearchFiltersDto;
    count?: number;
}

function flattenProperties(properties: SemanticSearchPropertyDto[][]): SemanticSearchPropertyDto[] {
    return properties.flatMap((group) => group);
}

export function SemanticSearchPropertyList(props: Props) {
    const {properties, filters, count} = props;
    const history = useHistory();
    const modalSize = useAppSelector((state) => getSemanticSearchModalSize(state.semanticSearchModal.surfacePhase));

    const items = properties ? flattenProperties(properties) : [];
    const listingUrl = buildSemanticSearchOfferListUrl(filters);
    const shouldShowListingLink = !!listingUrl && (filters?.regions?.length ?? 0) <= MAX_LISTING_REGIONS;
    const listingLinkLabel = typeof count === "number" ? `Zobacz wszystkie ${count} ${offersPluralize(count)}` : "Zobacz wszystkie oferty";

    const handleListingLinkClick = (event: MouseEvent<HTMLElement>) => {
        hitAiAssistantOffers(listingLinkLabel, filters?.regions ?? []);

        trackAmplitudeSemanticSearchSelectItem({
            modalSize,
            analyticSessionId: getAnalyticsSessionId(),
            item: {itemCategory: "see_all_offers", itemName: listingLinkLabel}
        });

        const isPlainLeftClick = event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;

        if (!listingUrl || event.defaultPrevented || !isPlainLeftClick) return;

        event.preventDefault();
        history.push(listingUrl);
    };

    if (!properties || properties.length === 0) {
        return null;
    }

    if (items.length === 0) {
        return null;
    }

    return (
        <div className={propertyListSection}>
            <PropertyCarousel ariaLabel="Mieszkania dopasowane przez Doradcę AI" itemCount={items.length} className={carouselWrapper}>
                {items.map((property, index) => (
                    <SemanticSearchPropertyListTile key={`${property.id}-${index}`} property={property} index={index} />
                ))}
            </PropertyCarousel>

            {shouldShowListingLink && (
                <Button
                    variant="none_secondary"
                    size="small"
                    as="a"
                    href={listingUrl}
                    className={listingLinkButton}
                    iconRight={ChevronRightIcon}
                    onClick={handleListingLinkClick}
                >
                    {listingLinkLabel}
                </Button>
            )}
        </div>
    );
}

const propertyListSection = css({
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    minWidth: 0
});

const carouselWrapper = css({
    borderTop: "1px solid var(--colors-gray-300)",
    pt: 2
});

const listingLinkButton = css({
    alignSelf: "flex-start",
    p: 0,
    minHeight: "auto",
    textTransform: "uppercase",
    fontWeight: 700
});
